// EHS checklist reference data for the CI admin EHS page.
//
// MIRRORED from the mobile app's source of truth:
//   sowash-fo-app/constants/ehsQuestions.ts  (EHS_DATA)
// The mobile app submits answers keyed by question id (q1..q90) plus a 0-based
// day_index. The DB stores only those keys, so the admin UI maps them back to
// the human question text here. If the mobile checklist changes, update this file.

// Day titles by 0-based day_index.
export const EHS_DAY_TITLES = [
  'Day 1 - Panel Safety',
  'Day 2 - PPE Compliance',
  'Day 3 - Uniform & Entry',
  'Day 4 - Supervision',
  'Day 5 - Water Usage',
  'Day 6 - Electrical Safety',
  'Day 7 - Tools & Equipment',
  'Day 8 - Housekeeping',
  'Day 9 - Working at Height',
  'Day 10 - Weather Conditions',
  'Day 11 - Hydration',
  'Day 12 - Chemical Handling',
  'Day 13 - Manual Handling',
  'Day 14 - Incident Reporting',
  'Day 15 - Escalation',
  'Day 16 - Authorization',
  'Day 17 - PPE Check',
  'Day 18 - Equipment Placement',
  'Day 19 - Attendance & TBT',
  'Day 20 - Discipline',
  'Day 21 - Site Readiness',
  'Day 22 - Weather Check',
  'Day 23 - Supervisor Responsibility',
  'Day 24 - Communication',
  'Day 25 - Fatigue & Health',
  'Day 26 - Compliance',
  'Day 27 - Documentation',
  'Day 28 - Review',
  'Day 29 - Readiness Check',
  'Day 30 - Final Reminder',
];

// English question text keyed by question id (q1..q90).
export const EHS_QUESTIONS = {
  q1: 'Is walking on solar panels allowed?',
  q2: 'Are designated walkways mandatory?',
  q3: 'Will violation lead to site removal?',
  q4: 'Are non-slip shoes mandatory today?',
  q5: 'Are gloves required during washing?',
  q6: 'Is helmet compulsory on site?',
  q7: 'Can anyone enter site without full uniform?',
  q8: "Is uniform check supervisor's responsibility?",
  q9: 'Should work start without uniform check?',
  q10: 'Can washing start without supervisor approval?',
  q11: 'Must supervisor remain present on site?',
  q12: 'Is site briefing required before work?',
  q13: 'Should high-pressure water be avoided?',
  q14: 'Can hot panels be washed with water?',
  q15: 'Best time for cleaning is morning/evening?',
  q16: 'Is touching junction boxes allowed?',
  q17: 'Should cables be visually inspected first?',
  q18: 'Are non-conductive tools preferred?',
  q19: 'Must tools be checked before use?',
  q20: 'Can damaged hose be used?',
  q21: 'Can tools be placed on panels?',
  q22: 'Is clean site important for safety?',
  q23: 'Can water runoff cause slipping?',
  q24: 'Should obstacles be removed immediately?',
  q25: 'Is harness required on roof work?',
  q26: 'Can work continue in windy conditions?',
  q27: 'Is fall protection mandatory?',
  q28: 'Is cleaning allowed during rain?',
  q29: 'Can thunderstorms increase electrical risk?',
  q30: 'Should work stop in extreme heat?',
  q31: 'Are water breaks important today?',
  q32: 'Can fatigue cause accidents?',
  q33: 'Should team be reminded to hydrate?',
  q34: 'Are only approved chemicals allowed?',
  q35: 'Must safety instructions be followed?',
  q36: 'Should chemicals be stored away from sun?',
  q37: 'Is correct lifting technique required?',
  q38: 'Should over-stretching be avoided?',
  q39: 'Is team lifting preferred for heavy loads?',
  q40: 'Must near misses be reported?',
  q41: 'Who reports incidents first - supervisor?',
  q42: 'Is delay in reporting acceptable?',
  q43: 'Should unsafe conditions be escalated?',
  q44: 'Supervisor informs line manager?',
  q45: 'Can work stop without informing manager?',
  q46: 'Can untrained staff wash panels?',
  q47: 'Is authorization mandatory?',
  q48: 'Is safety briefing required daily?',
  q49: 'Helmet worn by all today?',
  q50: 'Gloves and shoes checked?',
  q51: 'Any PPE missing on site?',
  q52: 'Are tools kept off panels?',
  q53: 'Are hoses properly routed?',
  q54: 'Any tripping hazard visible?',
  q55: 'Was toolbox talk conducted today?',
  q56: 'Was attendance recorded?',
  q57: 'Was selfie taken for proof?',
  q58: 'Are violations recorded?',
  q59: 'Is warning process clear to team?',
  q60: 'Zero tolerance for panel walking?',
  q61: 'Site inspected before start?',
  q62: 'Any visible electrical risk?',
  q63: 'Area safe to proceed?',
  q64: 'Weather checked before work?',
  q65: 'Wind/rain risk present?',
  q66: 'Work postponed if unsafe?',
  q67: 'Supervisor present full shift?',
  q68: 'Team following instructions?',
  q69: 'Any deviation observed?',
  q70: 'Safety instructions understood by team?',
  q71: 'Language barrier addressed?',
  q72: 'Any safety question from workers?',
  q73: 'Any worker fatigued today?',
  q74: 'Adequate rest breaks given?',
  q75: 'Heat stress monitored?',
  q76: 'All protocols followed today?',
  q77: 'Any non-compliance noted?',
  q78: 'Corrective action taken?',
  q79: 'Safety forms updated?',
  q80: 'Signatures completed?',
  q81: 'Records uploaded on app?',
  q82: 'Any repeated safety issue?',
  q83: 'Team reminded about panel walking ban?',
  q84: 'Supervisor satisfied with safety level?',
  q85: "Team fit for tomorrow's work?",
  q86: 'Equipment ready?',
  q87: 'PPE available for all?',
  q88: 'Zero walking on panels confirmed?',
  q89: 'Supervisor accountable for safety?',
  q90: 'Safety before speed - agree?',
};
